import React from 'react';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

let CarouselSettings = {
    showStatus: false,
    showThumbs: false,
    infiniteLoop: true,
    showIndicators: true,
    autoPlay: true,
    preventMovementUntilSwipeScrollTolerance: true,
    swipeScrollTolerance: 50,
};

const Slider = ({ values }) => {    
    CarouselSettings.showIndicators = values.length > 1 ? true : false;
    CarouselSettings.swipeable = values.length > 1 ? true : false;
    CarouselSettings.infiniteLoop = values.length > 1 ? true : false;
    return (
        <Carousel {...CarouselSettings}>
            {values.map((value, index) =>
                <a className={`slider__link ${value.withOverlay ? "image-overlay" : ""}`} href={value.url} key={`figure${index}`}>
                    <div className="slider__image" dangerouslySetInnerHTML={{ __html: value.htmlImage }}></div>
                    <div className="slider__text-container" style={value.textcolor !== "" ? { color: value.textcolor } : {}}>
                        {value.pretitle && <h4 className={`slider__pretitle ${value.textcolor === "" ? (value.lightText ? "text--light" : "text--dark") : ""}`}>{value.pretitle}</h4>}
                        {value.text && <h1 className={`slider__text ${value.textcolor === "" ? (value.lightText ? "text--light" : "text--dark") : ""}`}>{value.text}</h1>}
                    </div>
                </a>
            )}
        </Carousel>
    )
}

export default Slider;